import * as _ from "lodash";



export interface BreadcrumbProperties {
    pathMap: {[name: string]: string},
    dropdownMap: {[name: string]: string},
    searchByX: string
}

export class Breadcrumbs {
    properties: BreadcrumbProperties;
    template = _.template(require('templates/account/breadcrumb.html'));

    constructor(properties: BreadcrumbProperties) {
        this.properties = properties;
    }

    generateHTML() {
        return this.template({
            properties: this.properties
        });
    }

}


// WEBPACK FOOTER //
// ./srv/public/js/common/breadcrumbs.ts